var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOdd2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 324,
    height: 352,
    viewBox: "0 0 324 322",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M33.5019 73.2589C40.5034 96.348 82.7573 145.648 110.004 141.253C141.004 136.253 165.003 165.754 190.003 162.758C230.234 157.937 244.504 166.254 253.844 176.908C269.735 195.034 281.887 225.831 275.002 247.254",
    stroke: "#FFAA00",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M283.503 246.752C269.625 203.673 209.005 219.618 178.005 168.758C149.892 122.636 124.69 126.758 75.0047 126.758C33.5047 126.758 37.5044 95.7525 16.0044 73.7525",
    stroke: "#EA00B0",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M289 245.754C297.673 176.109 228.502 140.309 191.002 154.753C150.5 170.354 94.5024 150.753 85.0024 143.753C48.3238 116.727 69.0025 89.7534 41.0025 72.7534",
    stroke: "#00B3AE",
    strokeWidth: 2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOdd2);
export default __webpack_public_path__ + "static/media/odd2.1c86cce8e8dab8c940f17221d3e25f2e.svg";
export { ForwardRef as ReactComponent };